import dotProp from 'dot-prop-immutable'
import html2canvas from 'html2canvas'
import { push } from 'connected-react-router'
import { deselectPhoto } from './photos'
import { deselectFrame } from './project/frame'
import {
  LOAD_PROJECT,
  RENAME_PROJECT,
  SELECT_PHOTO,
  CREATED_PROJECT,
  SAVE_PROJECT,
  REMOVE_SETS
} from '../constants/projectActions'
import putProject from '../repositories/putProject'
import getProject from '../repositories/getProject'
import postProject from '../repositories/createProject'

export const selectPhoto = photoIndex => (dispatch, ownState) => {
  const index = dotProp.get(ownState(), 'project.selectedIndex', -1)
  if (index < 0) {
    return
  }

  const src = dotProp.get(ownState(), `photos.images.${photoIndex}.src`, '')
  dispatch(deselectPhoto())
  dispatch({ type: SELECT_PHOTO, index, src })
}

export const saveProject = () => (dispatch, ownState) => {
  dispatch(deselectFrame(dispatch, ownState))

  const projectState = ownState().project
  dispatch({type: 'SET_ALL_PICTURES', pictures: projectState.pictures.filter(p => p && p.selectedImage)})
  dispatch({type: REMOVE_SETS})

  projectState.pictures = projectState.pictures.filter(p =>  p && p.selectedImage)

  const redirectURL =
    localStorage.getItem('redirect_to') === '' || localStorage.getItem('redirect_to') === null
      ? `${process.env.REACT_APP_CLIENT_URL}/dashboard/orders/${localStorage.getItem('order_id')}/show#step-3`
      : localStorage.getItem('redirect_to')
  localStorage.removeItem('redirect_to')

    setTimeout(() => html2canvas(document.getElementById('wall-app'), {
    useCORS: true,
    logging: process.env.NODE_ENV !== 'production',
  })
    .then(canvas => {
      dispatch({ type: SAVE_PROJECT })
      return putProject(window.fetch)(projectState, dispatch, canvas.toDataURL())
    })
    .then(res => {
      if (res.status < 200 || res.status > 299) {
        throw new Error('Cannot save project!')
      }

      return res
    })
    .then(() => (window.location = redirectURL))
    .catch(err => {
      dispatch({ type: SAVE_PROJECT })
      err.message === '' ? window.alert(err.name) : window.alert(err)
    }), 300)
}

export const loadProject = id => (dispatch, ownState) => {
  getProject(window.fetch)(id)
    .then(metadata => dispatch({ type: LOAD_PROJECT, state: metadata }))
    .catch(() => dispatch(push('/')))
}
export const renameProject = name => ({ type: RENAME_PROJECT, name })
export const createProject = () => (dispatch, ownState) => {
  const projectName = dotProp.get(ownState(), 'project.name')

  postProject(fetch)(projectName).then(res => {
    const id = res.id
    dispatch({ type: CREATED_PROJECT, id })

    dispatch(push(`/${id}`))
  })
}



// WEBPACK FOOTER //
// ./src/actions/project.js